import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hskoplmiqevxgpyxafwo.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhza29wbG1pcWV2eGdweXhhZndvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4MjQwMDYsImV4cCI6MjA2OTQwMDAwNn0.BdMvTbhD-zwMvcwml8f7lrR5nlgebP33UZR1VWVmfoQ'

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 